module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "big-table"
  }, [(_vm.table) ? _c('div', {
    staticClass: "table-holder",
    on: {
      "scroll": _vm.handleTableScroll
    }
  }, [_c('table', {
    staticClass: "mdl-data-table mdl-js-data-table mdl-shadow--2dp"
  }, [_c('thead', {
    style: ({
      top: _vm.tableScrollY + 'px'
    })
  }, [_c('tr', _vm._l((_vm.table.columnNames), function(columnName, colId) {
    return _c('th', {
      staticClass: "sort",
      class: [{
        desc: _vm.sortColumn == columnName && !_vm.sortAsc,
        asc: _vm.sortColumn == columnName && _vm.sortAsc,
        'mdl-data-table__cell--non-numeric': _vm.table.columnTypes[colId] != 'number'
      }, 'col-' + _vm.table.columnTypes[colId]],
      on: {
        "click": function($event) {
          _vm.toggleSort(columnName)
        }
      }
    }, [_c('span', {
      attrs: {
        "id": _vm.generateId('th-' + columnName)
      }
    }, [_vm._v(_vm._s(_vm.table.displayColumnNames[colId]))]), _vm._v(" "), _c('div', {
      staticClass: "mdl-tooltip",
      attrs: {
        "data-mdl-for": _vm.generateId('th-' + columnName)
      }
    }, [_vm._v("\n              " + _vm._s(_vm.table.displayColumnNames[colId]) + "\n            ")])])
  })), _vm._v(" "), (_vm.showSummary) ? _c('tr', [_c('td', {
    staticClass: "mdl-data-table__cell--non-numeric"
  }, [_vm._v("\n            Summary:\n          ")]), _vm._v(" "), _vm._l((_vm.table.columnNames.slice(1)), function(columnName, colId) {
    return _c('td', {
      class: [{
        'mdl-data-table__cell--non-numeric': _vm.table.columnTypes[colId + 1] != 'number'
      }, 'col-' + _vm.table.columnTypes[colId + 1], _vm.generateClass(_vm.table.columnNames[colId + 1])]
    }, [_c('span', {
      attrs: {
        "id": _vm.generateId('sum-' + columnName)
      }
    }, [_vm._v(_vm._s(_vm.cellText(_vm.table.summary[colId + 1])))])])
  })], 2) : _vm._e()]), _vm._v(" "), _c('tbody', {
    style: ({
      marginTop: (_vm.tableMargins[0] + _vm.tableTopHeight) + 'px',
      marginBottom: _vm.tableMargins[1] + 'px'
    })
  }, _vm._l((_vm.visiblePart), function(row, vRowId) {
    return _c('tr', {
      key: _vm.visiblePartRowsRange[0] + vRowId
    }, _vm._l((row), function(cell, colId) {
      return _c('td', {
        key: colId,
        class: [{
            'mdl-data-table__cell--non-numeric': _vm.table.columnTypes[colId] != 'number',
            found: _vm.foundMap[(_vm.visiblePartRowsRange[0] + vRowId) + '-' + (colId)]
          },
          'col-' + _vm.table.columnTypes[colId],
          _vm.generateClass(_vm.table.columnNames[colId])
        ]
      }, [(_vm.table.columnTypes[colId] != 'ad') ? _c('span', {
        attrs: {
          "id": _vm.generateId('td-' + (_vm.visiblePartRowsRange[0] + vRowId) + '-' + colId),
          "title": _vm.cellText(cell)
        }
      }, [_vm._v("\n                  " + _vm._s(_vm.cellText(cell)) + "\n                ")]) : _vm._e(), _vm._v(" "), (_vm.table.columnTypes[colId] == 'ad') ? _c('div', {
        staticClass: "ad",
        attrs: {
          "id": _vm.generateId('td-' + (_vm.visiblePartRowsRange[0] + vRowId) + '-' + colId),
          "title": cell.title
        }
      }, [_c('div', {
        staticClass: "title"
      }, [_vm._v("\n                    " + _vm._s(cell.title) + "\n                  ")]), _vm._v(" "), _c('div', {
        staticClass: "text"
      }, [_vm._v("\n                    " + _vm._s(cell.text) + "\n                  ")]), _vm._v(" "), _c('div', {
        staticClass: "url"
      }, [_vm._v("\n                    " + _vm._s(cell.url) + "\n                  ")])]) : _vm._e()])
    }))
  }))])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-401c6c64"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/utils/BigTable.vue
// module id = 441
// module chunks = 0